/** 公開の頁の頭の帯の絵の住所 (ship.mjs が書く。手で直さない)。wide は 960、1440、1800、2240 幅、sp はスマホの右の絵だけ 716 幅 */
export const PUBLIC_ART_BANDS = {
  "jobs": {
    "wide": [
      "/assets/page-art/jobs-960-80e1e8eb13.webp",
      "/assets/page-art/jobs-1440-d5a516f825.webp",
      "/assets/page-art/jobs-1800-3c8ab84c9a.webp",
      "/assets/page-art/jobs-2240-89ccbfc9f4.webp"
    ],
    "sp": "/assets/page-art/jobs-sp-716-3771c8803b.webp"
  },
  "jobs-detail": {
    "wide": [
      "/assets/page-art/jobs-detail-960-34f8e942cd.webp",
      "/assets/page-art/jobs-detail-1440-0b36d6cd9a.webp",
      "/assets/page-art/jobs-detail-1800-fde932150d.webp",
      "/assets/page-art/jobs-detail-2240-84b2e51b99.webp"
    ],
    "sp": "/assets/page-art/jobs-detail-sp-716-da801374ca.webp"
  },
  "companies": {
    "wide": [
      "/assets/page-art/companies-960-a770f32280.webp",
      "/assets/page-art/companies-1440-4e5a335450.webp",
      "/assets/page-art/companies-1800-4161de164a.webp",
      "/assets/page-art/companies-2240-82902a3a01.webp"
    ],
    "sp": "/assets/page-art/companies-sp-716-e56315c137.webp"
  },
  "company-detail": {
    "wide": [
      "/assets/page-art/company-detail-960-6de6b64f91.webp",
      "/assets/page-art/company-detail-1440-f803a7846b.webp",
      "/assets/page-art/company-detail-1800-03104839c6.webp",
      "/assets/page-art/company-detail-2240-db5c20a820.webp"
    ],
    "sp": "/assets/page-art/company-detail-sp-716-e4542ef402.webp"
  },
  "creators": {
    "wide": [
      "/assets/page-art/creators-960-f491178da8.webp",
      "/assets/page-art/creators-1440-db6ab04df3.webp",
      "/assets/page-art/creators-1800-a8612dec84.webp",
      "/assets/page-art/creators-2240-da19875070.webp"
    ],
    "sp": "/assets/page-art/creators-sp-716-bd5a73dcb9.webp"
  },
  "teachers": {
    "wide": [
      "/assets/page-art/teachers-960-b22c9bdb33.webp",
      "/assets/page-art/teachers-1440-356dbae190.webp",
      "/assets/page-art/teachers-1800-165ca76ecc.webp",
      "/assets/page-art/teachers-2240-2c6d0451ea.webp"
    ],
    "sp": "/assets/page-art/teachers-sp-716-89f6aaf53d.webp"
  },
  "voices": {
    "wide": [
      "/assets/page-art/voices-960-6c4e0ad566.webp",
      "/assets/page-art/voices-1440-eaf06fe66a.webp",
      "/assets/page-art/voices-1800-0f76d68dcb.webp",
      "/assets/page-art/voices-2240-5eba5a0b33.webp"
    ],
    "sp": "/assets/page-art/voices-sp-716-e9cdbb8404.webp"
  },
  "founder": {
    "wide": [
      "/assets/page-art/founder-960-0c39c6b189.webp",
      "/assets/page-art/founder-1440-4e6a57b9f5.webp",
      "/assets/page-art/founder-1800-951a4df058.webp",
      "/assets/page-art/founder-2240-4109653eea.webp"
    ],
    "sp": "/assets/page-art/founder-sp-716-396db65fa3.webp"
  },
  "faq": {
    "wide": [
      "/assets/page-art/faq-960-2054a97876.webp",
      "/assets/page-art/faq-1440-1c6ac4400b.webp",
      "/assets/page-art/faq-1800-d32ab11170.webp",
      "/assets/page-art/faq-2240-1f035e679c.webp"
    ],
    "sp": "/assets/page-art/faq-sp-716-e41eaf32aa.webp"
  },
  "decision": {
    "wide": [
      "/assets/page-art/decision-960-915883e02d.webp",
      "/assets/page-art/decision-1440-4e470188ae.webp",
      "/assets/page-art/decision-1800-456a3a7570.webp",
      "/assets/page-art/decision-2240-c24e651b2a.webp"
    ],
    "sp": "/assets/page-art/decision-sp-716-bc343ad9cb.webp"
  },
  "verdict-self-study": {
    "wide": [
      "/assets/page-art/verdict-self-study-960-07dfb1266b.webp",
      "/assets/page-art/verdict-self-study-1440-cd009dddd7.webp",
      "/assets/page-art/verdict-self-study-1800-93f2ff2cd7.webp",
      "/assets/page-art/verdict-self-study-2240-991f212789.webp"
    ],
    "sp": "/assets/page-art/verdict-self-study-sp-716-9c4267e6de.webp"
  },
  "verdict-yumesaku-code": {
    "wide": [
      "/assets/page-art/verdict-yumesaku-code-960-108d93b040.webp",
      "/assets/page-art/verdict-yumesaku-code-1440-66e22ef11f.webp",
      "/assets/page-art/verdict-yumesaku-code-1800-0b24085e23.webp",
      "/assets/page-art/verdict-yumesaku-code-2240-238d314c1c.webp"
    ],
    "sp": "/assets/page-art/verdict-yumesaku-code-sp-716-441bed9526.webp"
  },
  "verdict-free-trial": {
    "wide": [
      "/assets/page-art/verdict-free-trial-960-3c919af614.webp",
      "/assets/page-art/verdict-free-trial-1440-8e7c803630.webp",
      "/assets/page-art/verdict-free-trial-1800-2871cfe063.webp",
      "/assets/page-art/verdict-free-trial-2240-a245089cce.webp"
    ],
    "sp": "/assets/page-art/verdict-free-trial-sp-716-e559e3f4aa.webp"
  },
  "verdict-counseling": {
    "wide": [
      "/assets/page-art/verdict-counseling-960-ad5cde862d.webp",
      "/assets/page-art/verdict-counseling-1440-5f5008acbf.webp",
      "/assets/page-art/verdict-counseling-1800-e7828f9665.webp",
      "/assets/page-art/verdict-counseling-2240-992eb02e5f.webp"
    ],
    "sp": "/assets/page-art/verdict-counseling-sp-716-f427bd0f03.webp"
  },
  "about": {
    "wide": [
      "/assets/page-art/about-960-b9ee4d49ba.webp",
      "/assets/page-art/about-1440-fa22bb8879.webp",
      "/assets/page-art/about-1800-72e4eaddb0.webp",
      "/assets/page-art/about-2240-5f8e974b65.webp"
    ],
    "sp": "/assets/page-art/about-sp-716-7e6fdb7222.webp"
  },
  "contact": {
    "wide": [
      "/assets/page-art/contact-960-87d157b186.webp",
      "/assets/page-art/contact-1440-2a2e269541.webp",
      "/assets/page-art/contact-1800-72870ac531.webp",
      "/assets/page-art/contact-2240-0a20bb108e.webp"
    ],
    "sp": "/assets/page-art/contact-sp-716-2af7cca8eb.webp"
  },
  "news": {
    "wide": [
      "/assets/page-art/news-960-a49ef44cb6.webp",
      "/assets/page-art/news-1440-5cf59a4e68.webp",
      "/assets/page-art/news-1800-90ca8b7103.webp",
      "/assets/page-art/news-2240-fbf577431b.webp"
    ],
    "sp": "/assets/page-art/news-sp-716-80134e8e2f.webp"
  },
  "privacy": {
    "wide": [
      "/assets/page-art/privacy-960-13664f441c.webp",
      "/assets/page-art/privacy-1440-ff02bf8412.webp",
      "/assets/page-art/privacy-1800-39c42aead3.webp",
      "/assets/page-art/privacy-2240-d511228a43.webp"
    ],
    "sp": "/assets/page-art/privacy-sp-716-1010c2f7dd.webp"
  },
  "terms": {
    "wide": [
      "/assets/page-art/terms-960-372c6348cd.webp",
      "/assets/page-art/terms-1440-62c6923760.webp",
      "/assets/page-art/terms-1800-cc57a41d4b.webp",
      "/assets/page-art/terms-2240-8342b497ef.webp"
    ],
    "sp": "/assets/page-art/terms-sp-716-9c608eff61.webp"
  },
  "sitemap": {
    "wide": [
      "/assets/page-art/sitemap-960-b25d9f9354.webp",
      "/assets/page-art/sitemap-1440-9860ceb4f2.webp",
      "/assets/page-art/sitemap-1800-9518e28a22.webp",
      "/assets/page-art/sitemap-2240-422c715ceb.webp"
    ],
    "sp": "/assets/page-art/sitemap-sp-716-5bcabe7173.webp"
  },
  "skills": {
    "wide": [
      "/assets/page-art/skills-960-f90f1612db.webp",
      "/assets/page-art/skills-1440-c4cadf9c5e.webp",
      "/assets/page-art/skills-1800-535bdf00f5.webp",
      "/assets/page-art/skills-2240-6abb16dedf.webp"
    ],
    "sp": "/assets/page-art/skills-sp-716-17a080508c.webp"
  },
  "skills-set": {
    "wide": [
      "/assets/page-art/skills-set-960-a23170e68b.webp",
      "/assets/page-art/skills-set-1440-c21e64ab94.webp",
      "/assets/page-art/skills-set-1800-2495c98a12.webp",
      "/assets/page-art/skills-set-2240-42fd449504.webp"
    ],
    "sp": "/assets/page-art/skills-set-sp-716-225e384e56.webp"
  },
  "portfolio": {
    "wide": [
      "/assets/page-art/portfolio-960-c4eeb5c65d.webp",
      "/assets/page-art/portfolio-1440-89e15a0a94.webp",
      "/assets/page-art/portfolio-1800-f07c236b92.webp",
      "/assets/page-art/portfolio-2240-7085451fe0.webp"
    ],
    "sp": "/assets/page-art/portfolio-sp-716-724a82a180.webp"
  },
  "guides-ranking": {
    "wide": [
      "/assets/page-art/guides-ranking-960-584de2de71.webp",
      "/assets/page-art/guides-ranking-1440-5c2a4bec8b.webp",
      "/assets/page-art/guides-ranking-1800-f94941758c.webp",
      "/assets/page-art/guides-ranking-2240-162431ad11.webp"
    ],
    "sp": "/assets/page-art/guides-ranking-sp-716-54a10db86d.webp"
  },
  "jobs-policy": {
    "wide": [
      "/assets/page-art/jobs-policy-960-6bbe9019af.webp",
      "/assets/page-art/jobs-policy-1440-18eb2b8107.webp",
      "/assets/page-art/jobs-policy-1800-c26b665b12.webp",
      "/assets/page-art/jobs-policy-2240-b291e12bd0.webp"
    ],
    "sp": "/assets/page-art/jobs-policy-sp-716-b87a0d8dc4.webp"
  }
} as const;
